import Timer from 'src/helpers/timer';

export class AudioRecorder {
  constructor(duration, timeListen) {
    this.duration = duration;

    this.stream = null;

    this.mediaRecorder = null;

    this.blobsRecorded = [];

    this.timer = new Timer(
      () => {
        console.log('time finished');
        this.stopRecording();
      },
      this.duration * 1000,
      timeListen
    );
  }

  async getUserMedia() {
    const constrains = {
      audio: true
    };

    this.stream = await navigator.mediaDevices.getUserMedia(constrains);

    return this.stream;
  }

  startMediaRecording() {
    if (!this.mediaRecorder || this.mediaRecorder.state === 'inactive') {
      if (!this.stream) {
        throw new Error('Make sure you have granted permission to your camera');
      }

      this.timer.start();

      // set MIME type of recording as video/webm
      this.mediaRecorder = new MediaRecorder(this.stream);

      // event : new recorded video blob available
      this.mediaRecorder.addEventListener('dataavailable', (e) => {
        this.blobsRecorded.push(e.data);
      });

      // event : recording stopped & all blobs sent
      this.mediaRecorder.addEventListener('stop', () => {
        this.timer.timeListen.stop && this.timer.timeListen.stop();
      });

      // start recording with each recorded blob having 1 second video
      this.mediaRecorder.start(1000);
    } else {
      this.timer.resume();
      this.mediaRecorder.resume();
    }
  }

  startRecording() {
    this.startMediaRecording();
  }

  pauseRecording() {
    this.timer.pause();
    if (this.mediaRecorder) {
      this.mediaRecorder.pause();
    }
  }

  stopRecording() {
    this.timer.pause();
    if (this.mediaRecorder) {
      this.mediaRecorder.stop();
    }
  }

  saveRecord() {
    const blob = new Blob(this.blobsRecorded, { type: this.mediaRecorder.mimeType });

    return {
      record: blob,
      date: new Date()
    };
  }
}
